<div id="thankyou">
    <div class="header shadow-sm">
        <div class="container">
            <div class="header-inner">
                <div class="logo py-2 hide-mobile">
                    <a routerLink="/">
                        <img src="/assets/images/botlogo.png" alt="logo" width="80">
                    </a>
                </div>
                <div class="logo py-2 show-mobile">
                    <a routerLink="/">
                        <img src="/assets/images/bot-logo-mobile.png" alt="logo" width="30">
                    </a>
                </div>
            </div>
        </div>
    </div>
    
    <div class="main">
        <div class="thankyou-inner pt-5">
            <div class="container pt-3">
                <div class="img-block pt-5"> 
                    <figure>
                        <img src="./assets/images/thanku.png" alt="Thank You" class="img-thumbnail border-0">
                    </figure>
                </div>
                <div class="content-block ">
                    <div class="content-block-inner text-center ft-24 text-secondary">
                       We're Glad to See You Back Again..!!
                       <br>
                        Start Trading Now..
                    </div>
                    <div class="click-here-btn text-center py-2">
                        <button (click)="navigateToLogIn()" class="btn bg-darkblue text-light ft-14">Click Here</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>